import useContract from './useContract';
import INoundlesTheory from '../contracts/INoundlesTheory.json';

const useNoundlesTheory = () =>
  useContract(
    process.env.NEXT_PUBLIC_NOUNDLES_THEORY_CONTRACT_ADDRESS,
    INoundlesTheory.abi
  );

export default useNoundlesTheory;
